export default {
  hero: {
    status: 'Aberto aos desafios certos',
    description: 'Olá, sou um maker multidisciplinar <br /> baseado em Curitiba, PR-Brasil',
    title: {
      first: 'Product',
      highlight: 'Design',
      last: 'Engineer',
    },
    scroll: 'Scroll',
  },
  about: {
    watermark: 'Quem sou eu',
    title: 'Quem sou eu',
    seeMore: {
      label: 'Descobrir mais',
      title: 'Conheça-me',
    },
    story:
      "Cresci no Caribe, em uma <span class='story-highlight'>Venezuela</span> que moldava com dureza, dias bons, dias difíceis e uma criatividade nascida da urgência. Lá aprendi a resolver com pouco e a ver ordem onde outros viam caos. Em 2019 migrei para o <span class='story-highlight'>Brasil</span> em busca de estabilidade e um futuro mais claro. Esse salto me obrigou a começar do zero, me reinventar e provar que eu poderia subir de nível mesmo em terreno novo.",
    heroCard: {
      role: 'Desenvolvedor Criativo e Designer de Interfaces',
      bio: 'Apaixonado por criar experiências digitais que realmente se conectem com as pessoas. Combino a lógica do código com a empatia do design para construir soluções úteis, focando na eliminação de atritos para alcançar interfaces que pareçam familiares e naturais desde o primeiro instante.',
    },
    locationCard: {
      label: 'Baseado em',
      country: 'Brasil',
    },
    availabilityCard: {
      status: 'Disponível',
      message: 'para a coisa certa',
    },
    quoteCard: {
      philosophy: '— Minha filosofia',
      segments: [
        { text: 'Não busco a perfei', type: 'type' },
        { text: 'cao', type: 'type', isTypo: true },
        { text: '', type: 'pause', duration: 600 },
        { text: 'cao', type: 'delete' },
        { text: 'ção,', type: 'type' },
        { text: '', type: 'pause', duration: 800 },
        { text: ' só tento ser extraordinário.', type: 'type' },
      ],
    },
    experienceCard: {
      label: 'Anos de<br />Experiência',
    },
    neurodivergentCard: {
      teaser: "Tenho <span class='teaser__highlight'>superpoderes</span>",
      button: 'Quer ver?',
      label: 'Neurodivergente',
      hide: 'Ocultar',
      badges: {
        autism: 'Autismo N1',
        giftedness: 'Altas Habilidades',
      },
      superpowers: [
        { id: 'hyperfocus', name: 'Hiperfoco' },
        { id: 'patterns', name: 'Padrões' },
        { id: 'precision', name: 'Detalhe' },
        { id: 'logic', name: 'Lógica' },
      ],
      footer: "Não é um bug, é uma <span class='footer-highlight'>feature</span>",
    },
    hobbiesCard: {
      title: 'Além do sistema',
      text: 'Fé, ciência e o impulso de superação. Um equilíbrio entre o design de Deus, as leis da física e a disciplina de quebrar meus próprios limites.',
      hobbies: [
        'Deus',
        'Família',
        'Ciência',
        'Física',
        'Astrofísica',
        'Design',
        'Artes',
        'Música',
        'Gaming',
        'Dragon Ball',
      ],
    },
    readingCard: {
      title: 'Lendo atualmente',
    },
    familyCard: {
      title: "Família em primeiro lugar <span class='family-card__hearts'>❤️</span>",
      text: 'Minha família é minha força quando fraquejo, minha alegria quando estou exausto e a razão pela qual nunca paro. São minha prioridade, meu chão firme e minha bênção diária. Agradeço a Deus por nos guiar e sustentar em cada passo.',
    },
    momentsCard: {
      title: 'Momentos por trás dos pixels',
      labels: {
        alwaysLearning: 'Sempre aprendendo 📚',
        dreamTeam: 'Dream Team 💜',
      },
    },
    setupCard: {
      items: {
        dell: { detail: 'Core i7 13th Gen • GEFORCE RTX • 32GB RAM • 1TB SSD' },
        mic: { detail: 'Microfone Condensador USB' },
        webcam: { detail: 'Webcam 2k' },
        mouse: { detail: 'Mouse' },
        mousepad: { detail: 'Mousepad' },
        tablet: { detail: 'Tablet Gráfico' },
        buds1: { detail: 'Fones Sem Fio' },
        buds2: { detail: 'Fones Sem Fio' },
        headphones: { detail: 'Headphones Over-Ear' },
        keyboard: { detail: 'Teclado' },
        bible: { detail: 'Guia Espiritual' },
        book: { detail: 'Livro UX de Don Norman' },
        speaker: { detail: 'Smart Speaker' },
        monitor1: { detail: 'Full HD • IPS' },
        timer: { detail: 'Temporizador Pomodoro' },
        monitor2: { detail: 'Full HD • IPS' },
        controller: { detail: 'Para pausas de jogo 🎮' },
      },
    },
    languagesCard: {
      title: 'Idiomas',
      items: [
        { name: 'Espanhol', level: 'Nativo' },
        { name: 'Português', level: 'Fluente' },
        { name: 'Inglês', level: 'B2 e Aprendendo' },
      ],
    },
  },
  whatIDo: {
    title: {
      first: 'O que',
      highlight: 'Eu Faço',
    },
    services: {
      uiUx: {
        title: 'UI/UX',
        description:
          'Criando interfaces intuitivas centradas no usuário que combinam estética com funcionalidade perfeita',
      },
      frontend: {
        title: 'FRONTEND',
        description:
          'Engenharia de aplicações web escaláveis e de alto desempenho usando arquitetura moderna',
      },
      design: {
        title: 'DESIGN',
        description:
          'Forjando identidades visuais distintas e sistemas que contam uma história de marca convincente',
      },
      creative: {
        title: 'CRIATIVO',
        description: 'Orquestrando experiências digitais imersivas onde o código encontra a arte',
      },
    },
  },
  worksComingSoon: {
    badge: 'Em Construção',
    title: 'Analisando Ideias<br />Para a Realidade',
    description:
      'Atualmente estou selecionando meus melhores projetos para mostrar aqui. Espere algo especial em breve.',
    loading: {
      initializing: 'Inicializando...',
      states: [
        'Melhorando Casos de Uso...',
        'Projetando Fluxos de Usuário...',
        'Otimizando Ativos Gráficos...',
        'Refinando Interações...',
        'Preparando Documentação...',
        'Compilando Melhores Projetos...',
      ],
    },
  },
  journeyV2: {
    label: 'Cronograma de Carreira',
    title: 'Experiência',
    connect: 'Conectar no LinkedIn',
    items: [
      {
        id: 1,
        company: 'Compliance Soluções',
        role: 'Consultor Sênior/Especialista em Desenvolvimento UX',
        location: 'Remoto - Ribeirão Preto, São Paulo, Brasil',
        period: 'Mai 2022 - Atual',
        description:
          'Liderando a migração UX de uma plataforma fiscal legada atendendo a mais de 100 empresas. Otimizando fluxos de trabalho para mais de 20k faturas mensais através de pesquisa, prototipagem e colaboração próxima com Product Owners.',
        startYear: 2022,
        endYear: 2025,
      },
      {
        id: 2,
        company: 'Simplify Tanzania',
        role: 'Diretor de Arte',
        location: 'Remoto - Dar es Salaam, Tanzânia',
        period: 'Jun 2019 - Dez 2022',
        description:
          'Liderei a direção criativa desde a definição do MVP até a implementação frontend. Projetei interfaces de alta fidelidade para gestão de faturas e estabeleci a identidade visual da marca em canais digitais e sociais.',
        startYear: 2019,
        endYear: 2022,
        roles: [
          {
            title: 'Diretor de Arte',
            period: 'Fev 2021 - Out 2022',
            type: 'Tempo Integral',
          },
          {
            title: 'Designer de Produto UI/UX Sênior e Desenvolvedor Front-end',
            period: 'Out 2020 - Fev 2021',
            type: 'Contrato',
          },
        ],
      },
      {
        id: 3,
        company: 'Katavi Gaming Limited',
        role: 'Consultor Sênior de Design de Produto UI/UX',
        location: 'Dar es Salaam, Tanzânia',
        period: 'Out 2017 - Mai 2022',
        description:
          'Chefiei o departamento de UI/UX para plataformas de apostas, otimizando para acessibilidade de dispositivos. Gerenciei o ciclo completo de design desde a pesquisa até o lançamento usando SCRUM, enquanto definia a identidade corporativa e ativos de marketing.',
        startYear: 2017,
        endYear: 2022,
        roles: [
          {
            title: 'Consultor Sênior de Design de Produto UI/UX',
            period: 'Dez 2020 - Mai 2022',
            type: 'Freelance',
          },
          {
            title: 'Designer de Produto UI/UX e Desenvolvedor Front-end',
            period: 'Abr 2018 - Dez 2020',
            type: 'Tempo Integral',
          },
          {
            title: 'Desenvolvedor Front-end Júnior e Designer UI/UX',
            period: 'Out 2017 - Abr 2018',
            type: 'Tempo Integral',
          },
        ],
      },
      {
        id: 4,
        company: 'Freelancer',
        role: 'Designer de Produto e Desenvolvedor',
        location: 'Global',
        period: 'Jan 2016 -',
        description:
          'Fornecendo soluções versáteis de design e desenvolvimento para clientes globais. Os projetos variam desde a criação de identidades corporativas e embalagens para marcas educacionais até o design de interfaces para plataformas de jogos emergentes.',
        startYear: 2016,
        endYear: 2025,
      },
    ],
  },
  testimonials: {
    title: 'Impacto Colaborativo',
    subtitle: 'Tive o prazer de colaborar com pessoas incríveis. Aqui está o que elas têm a dizer.',
    items: [
      {
        id: 1,
        initials: 'J. A.',
        name: 'Jesus A. A. Rojas',
        role: 'Chefe de Armazém na Traslogistic de Venezuela',
        company: 'TBET',
        quote:
          'Juan tem um poder criativo incrível, aprende rápido e é autodidata. Ele tem a habilidade de captar a visão do projeto e usar suas habilidades para melhorá-lo ou agregar valor.',
        linkedin: 'https://www.linkedin.com/in/jesus-armando-acosta-rojas/',
      },
      {
        id: 2,
        initials: 'B. C.',
        name: 'Baraka S. Cassian',
        role: 'Fundador e Diretor Geral, Simplitech Ltd (Simplify)',
        company: 'SIMPLIFY',
        quote:
          'Trabalhar com Juan no produto e na experiência frontend da Simplify foi um prazer. Ele entendeu rapidamente nosso produto, nossos usuários e as restrições em que operamos, e então traduziu ideias soltas em interfaces limpas e intuitivas. Apreciei como ele se comunicava claramente, iterava rápido no feedback e prestava atenção aos pequenos detalhes que fazem um produto parecer polido. Juan traz uma mistura rara de habilidade de design, confiabilidade e cuidado genuíno pelo resultado do projeto. Ele é, no geral, uma pessoa amigável e ótima para trabalhar!',
        linkedin: 'https://www.linkedin.com/in/bcassian/',
      },
      {
        id: 3,
        initials: 'C. Z.',
        name: 'Carlos Zerpa',
        role: 'Senior Software Enginner',
        company: 'SIMPLIFY',
        quote:
          'Trabalhar ao lado de Juan Lias no projeto Simplify VFD foi um testemunho de seu talento excepcional. Sua liderança em design de produto, aliada à sua experiência em Vue.js, resultou em uma aplicação polida e intuitiva. Seu profissionalismo, atenção aos detalhes e espírito colaborativo o tornam um designer e desenvolvedor de destaque.',
        linkedin: 'https://www.linkedin.com/in/carlos-javier-zerpa/',
      },
      {
        id: 4,
        initials: 'M. V.',
        name: 'Mariana Vielma',
        role: 'Product Owner',
        company: 'SIMPLIFY',
        quote:
          'Juan é um profissional extraordinário com um talento incrível e um ótimo senso de humor, tornando a colaboração produtiva e agradável. Seus designs sempre carregam sua assinatura "centelha extra", aquele toque único que eleva cada projeto e deixa você querendo ver mais de seu trabalho. Ele consistentemente dá 100% em tudo o que faz, trazendo criatividade, atenção aos detalhes e visão forte que agregam valor real a qualquer produto ou equipe.',
        linkedin: 'https://www.linkedin.com/in/mariana-vielma-67585a237/',
      },
    ],
  },
}
